/**
 * Application configuration from environment variables
 */

// Determine API base URL based on environment
// In development: use full URL to backend server (localhost:8000)
// In production: use relative path (/api) for same-domain deployment
const getDefaultApiBaseUrl = () => {
  const env = import.meta.env.VITE_APP_ENV || import.meta.env.MODE || 'development';
  
  // If explicitly set, use that
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }
  
  // In development, default to backend server
  if (env === 'development' || import.meta.env.DEV) {
    return 'http://localhost:8000/api';
  }
  
  // In production, use relative path
  return '/api';
};

export const config = {
  apiBaseUrl: getDefaultApiBaseUrl(),
  apiVersion: import.meta.env.VITE_API_VERSION || 'v1',
  appEnv: import.meta.env.VITE_APP_ENV || import.meta.env.MODE || 'development',
  appName: import.meta.env.VITE_APP_NAME || 'IronSource Dashboard',
  appUrl: import.meta.env.VITE_APP_URL || window.location.origin,
};

/**
 * Get full API URL
 * @param {string} endpoint - API endpoint (e.g., '/health') - optional, if not provided returns base URL
 * @returns {string} Full API URL
 */
export const getApiUrl = (endpoint = '') => {
  const baseUrl = config.apiBaseUrl || '/api';
  const version = config.apiVersion || 'v1';
  
  // Ensure baseUrl doesn't end with slash
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  
  // If no endpoint provided, return base URL without trailing slash
  if (!endpoint) {
    return `${cleanBaseUrl}/${version}`;
  }
  
  // Ensure endpoint starts with slash
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  
  return `${cleanBaseUrl}/${version}${cleanEndpoint}`;
};

/**
 * Format date as YYYY-MM-DD
 */
const fmt = (d) => d.toISOString().split('T')[0];

/**
 * Default date range: today (same start and end).
 * Used for dashboard, analytics, revenue, performance, etc.
 */
export const getDefaultDateRange = () => {
  const today = new Date();
  const dateStr = fmt(today);
  return { startDate: dateStr, endDate: dateStr };
};
